import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useHistory } from "react-router";
import { useLocation } from "react-router";
import paymentStart from "../bookashoot_components/payment";
import Dashboardimageload from "./Dashboardimageload";
import "./NewUserDashboard.css";
import { packages } from "../packages_components/PackageData";
import swal from "sweetalert";
import axios from "../../axios.js";
import { useHCustomization } from "../../context";

const NewUserDashboard = () => {
  const { isAuth, setIsAuth } = useHCustomization();
  const history = useHistory();
  const location = useLocation();

  const logoutButtonHandler = () => {
    localStorage.clear();
    setIsAuth(false);
    history.push("/login");
  };
  let fname = "";
  let lname = "";
  let userMobile = "";
  let userEmail = "";
  let cityset = "";
  let [auth, setAuth] = useState([]);
  auth = JSON.parse(localStorage.getItem("auth"));

  useEffect(() => {
    setAuth(JSON.parse(localStorage.getItem("auth")));
  }, [location]);

  let citys = localStorage.getItem("city");

  if (citys) cityset = citys;
  if (auth) {
    fname = auth.result.firstname;
    lname = auth.result.lastname;
    userMobile = auth.result.mobile;
    userEmail = auth.result.email;
  }
  const [firstname, setFirstname] = useState(fname);
  const [lastname, setLastname] = useState(lname);
  const [email, setEmail] = useState(userEmail);
  const [mobile, setMobile] = useState(userMobile);
  const [city, setCity] = useState(cityset);
  const [service, setService] = useState();
  const [date, setDate] = useState();
  const [time, setTime] = useState();
  const [bookedPackage, setPackage] = useState();
  const [bookedPackagePrice, setPackagePrice] = useState();
  const [comment, setComment] = useState();
  const [coupon, setCoupon] = useState();
  const [gold, setGold] = useState(" - ");
  const [silver, setSilver] = useState(" - ");
  const [bronze, setBronze] = useState(" - ");

  const preFetchHandler = () => {
    // From localStorage if user is authorized page.
    setFirstname(localStorage.getItem("userFirstName"));
    setLastname(localStorage.getItem("userLastName"));
    setMobile(localStorage.getItem("userMobile"));
    setEmail(localStorage.getItem("userEmail"));
    serviceHandler();
  };

  const preFetchFromHistoryPush = () => {
    let detail = location.state.detail;

    setCity(detail.location);
    setFirstname(detail.c_name.split(" ")[0]);
    setLastname(detail.c_name.split(" ")[detail.c_name.split(" ").length - 1]);
    setMobile(detail.c_mobile);
    setEmail(detail.c_email);
    setService(detail.user_services1);
    setDate(detail.date);
    setTime(detail.time);
    setPackage(detail.c_package);
    setPackagePrice(detail.package_price);
  };
  const serviceHandler = () => {
    packages.find((pack) => {
      if (pack.title === service) {
        setGold(pack.price3);
        setSilver(pack.price2);
        setBronze(pack.price1);

        if (bookedPackage === "Gold") {
          setPackagePrice(pack.price3);
        } else if (bookedPackage === "Silver") {
          setPackagePrice(pack.price2);
        } else {
          setPackagePrice(pack.price1);
        }
        const price =
          document.getElementById("package").selectedOptions[0].attributes[1]
            .value;
        // setPackagePrice(price);
        // console.log(bookedPackagePrice)
      }
    });
  };

  //? Old >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>

  // const BookPackageHandler = async (e) => {
  //   e.preventDefault();
  //   //if request is form change operation then check is user clicked on book btn or not.
  //   if (location.state) {
  //     const id = location.state.detail.id;
  //     let api = process.env.REACT_APP_URL + `booking/delete_booking/${id}`;
  //     let res = await fetch(api, {
  //       headers: {
  //         "Content-Type": "application/json",
  //         Accept: "application/json",
  //       },
  //     });
  //     if (res.status < 200 || res.status >= 300) {
  //       swal("Something went wrong!");
  //     }
  //     let data = await res.json();

  //     if (res.status >= 200 && data.status < 300) {
  //       await swal("Updated!", "Your package updated successfully!", "success");
  //     } else {
  //       swal("Package does not exist, Refresh the page.");
  //     }
  //   }

  //   localStorage.setItem("service", service);
  //   localStorage.setItem("bookingdate", date);
  //   localStorage.setItem("bookingtime", time);
  //   localStorage.setItem("c_package", bookedPackage);
  //   localStorage.setItem("package_price", bookedPackagePrice);
  //   localStorage.setItem("first_name", firstname);
  //   localStorage.setItem("last_name", lastname);
  //   localStorage.setItem("email", email);
  //   localStorage.setItem("mobile", mobile);
  //   localStorage.setItem("city", city);
  //   paymentStart();
  //   // history.push("/dashboard");
  // };

  //? Old <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<

  const handleSubmit = async (e) => {
    e.preventDefault();

    const orderData = {
      firstname: firstname,
      lastname: lastname,
      email: email,
      mobile: mobile,
      city: city,
      service: service,
      date: date,
      time: time,
      package: bookedPackage,
      package_price: bookedPackagePrice,
      comment: comment,
      coupon: coupon,
    };

    try {
      const res = await axios.post("/book/request", orderData);
      console.log(res.data);

      history.push("/dashboard");
    } catch (error) {
      console.log(error);
    }

    console.log(orderData);
  };

  useEffect(() => {
    serviceHandler();
  }, [service]);

  //? old >>>>>>>>>>>>>>>>>>>>>>
  // useEffect(() => {
  //   if (!location.state) {
  //     preFetchHandler();
  //   } else {
  //     preFetchFromHistoryPush();
  //   }
  // }, []);

  //? old <<<<<<<<<<<<<<<<<<<<<<

  return (
    <div className="newUserDashboard__container">
      <div className="newUserDashboard-menu__container">
        <div className="newUserDashboard-menuContainer__img img-holder">
          <Dashboardimageload />
          <span> Welcome {firstname}! </span>{" "}
        </div>
        <div className="newUserDashboard-menuContainer__btns">
          <div className="newUserDashboard-button__container">
            <button
              onClick={logoutButtonHandler}
              className="NewUserDashboard-button"
            >
              Logout
            </button>
            <Link to="/">
              <button className="NewUserDashboard-button">Home</button>
            </Link>
          </div>
        </div>
      </div>
      <div className="dashboard_packageModal">
        <form className="book_package-form" onSubmit={handleSubmit}>
          <div className="input-group">
            <input
              type="text"
              placeholder="First Name"
              value={firstname}
              id="first_name"
              onChange={(val) => {
                setFirstname(val.target.value);
              }}
              required
            />

            <input
              type="text"
              placeholder="Last Name"
              value={lastname}
              id="last_name"
              onChange={(val) => {
                setLastname(val.target.value);
              }}
              required
            />
          </div>

          <div className="input-group">
            <select
              id="booked-city"
              value={city}
              onChange={(val) => {
                setCity(val.target.value);
              }}
              required
            >
              <option value=""> Search Destination </option>
              <option value="Agartala"> Agartala </option>{" "}
              <option value="Agra"> Agra </option>{" "}
              <option value="Ahemadabad"> Ahemadabad </option>{" "}
              <option value="Aizawl"> Aizawl </option>{" "}
              <option value="Ajmer"> Ajmer </option>{" "}
              <option value="Almora"> Almora </option>{" "}
              <option value="Amaravati"> Amaravati </option>{" "}
              <option value="Ambala"> Ambala </option>{" "}
              <option value="Amritsar"> Amritsar </option>{" "}
              <option value="Aurangabad"> Aurangabad </option>{" "}
              <option value="Ayodhya"> Ayodhya </option>{" "}
              <option value="Badrinath"> Badrinath </option>{" "}
              <option value="Bangalore"> Bangalore </option>{" "}
              <option value="Bhopal"> Bhopal </option>{" "}
              <option value="Bhubaneshwar"> Bhubaneshwar </option>{" "}
              <option value="Bikaner"> Bikaner </option>{" "}
              <option value="Bilaspur"> Bilaspur </option>{" "}
              <option value="Bodhgaya"> Bodhgaya </option>{" "}
              <option value="Calangute, Goa"> Calangute, Goa </option>{" "}
              <option value="Canacona, Goa"> Canacona, Goa </option>{" "}
              <option value="Chandigarh"> Chandigarh </option>{" "}
              <option value="Chennai"> Chennai </option>{" "}
              <option value="Chittoor"> Chittoor </option>{" "}
              <option value="Coimbatore"> Coimbatore </option>{" "}
              <option value="Dalhousie"> Dalhousie </option>{" "}
              <option value="Daman"> Daman </option>{" "}
              <option value="Darjeeling"> Darjeeling </option>{" "}
              <option value="Dehradun"> Dehradun </option>{" "}
              <option value="Delhi"> Delhi </option>{" "}
              <option value="Dharamshala"> Dharamshala </option>{" "}
              <option value="Dwarka"> Dwarka </option>{" "}
              <option value="Fatehpur Sikri"> Fatehpur Sikri </option>{" "}
              <option value="Gandhinagar"> Gandhinagar </option>{" "}
              <option value="Gangtok, Sikkim"> Gangtok, Sikkim </option>{" "}
              <option value="Gurgaon"> Gurgaon </option>{" "}
              <option value="Guwahati"> Guwahati </option>{" "}
              <option value="Gwalior"> Gwalior </option>{" "}
              <option value="Hampi"> Hampi </option>{" "}
              <option value="Haridwar"> Haridwar </option>{" "}
              <option value="Hyderabad"> Hyderabad </option>{" "}
              <option value="Imphal"> Imphal </option>{" "}
              <option value="Indore"> Indore </option>{" "}
              <option value="Itanagar"> Itanagar </option>{" "}
              <option value="Jabalpur"> Jabalpur </option>{" "}
              <option value="Jaipur"> Jaipur </option>{" "}
              <option value="Jaisalmer"> Jaisalmer </option>{" "}
              <option value="Jammu"> Jammu </option>{" "}
              <option value="Jhansi"> Jhansi </option>{" "}
              <option value="Jodhpur"> Jodhpur </option>{" "}
              <option value="Junagadh"> Junagadh </option>{" "}
              <option value="Kanpur"> Kanpur </option>{" "}
              <option value="Kasauli"> Kasauli </option>{" "}
              <option value="Kavaratti"> Kavaratti </option>{" "}
              <option value="Kedarnath"> Kedarnath </option>{" "}
              <option value="Kohima"> Kohima </option>{" "}
              <option value="Kolkata"> Kolkata </option>{" "}
              <option value="Kufri"> Kufri </option>{" "}
              <option value="Kullu"> Kullu </option>{" "}
              <option value="Leh"> Leh </option>{" "}
              <option value="Lucknow"> Lucknow </option>{" "}
              <option value="Madurai"> Madurai </option>{" "}
              <option value="Manali"> Manali </option>{" "}
              <option value="Mangalore"> Mangalore </option>{" "}
              <option value="Mathura"> Mathura </option>{" "}
              <option value="Mumbai"> Mumbai </option>{" "}
              <option value="Mussorie"> Mussorie </option>{" "}
              <option value="Mysore"> Mysore </option>{" "}
              <option value="Nagpur"> Nagpur </option>{" "}
              <option value="Nainital"> Nainital </option>{" "}
              <option value="Nashik"> Nashik </option>{" "}
              <option value="Ooty"> Ooty </option>{" "}
              <option value="Panaji, Goa"> Panaji, Goa </option>{" "}
              <option value="Patna, Bihar"> Patna, Bihar </option>{" "}
              <option value="Portblair"> Portblair </option>{" "}
              <option value="Prayagraj"> Prayagraj </option>{" "}
              <option value="Puducherry"> Puducherry </option>{" "}
              <option value="Pune"> Pune </option>{" "}
              <option value="Puri"> Puri </option>{" "}
              <option value="Raipur"> Raipur </option>{" "}
              <option value="Ranchi"> Ranchi </option>{" "}
              <option value="Raurkela"> Raurkela </option>{" "}
              <option value="Rishikesh"> Rishikesh </option>{" "}
              <option value="Rohtak"> Rohtak </option>{" "}
              <option value="Shillong"> Shillong </option>{" "}
              <option value="Shimla"> Shimla </option>{" "}
              <option value="Silchar"> Silchar </option>{" "}
              <option value="Silliguri"> Silliguri </option>{" "}
              <option value="Sonipat"> Sonipat </option>{" "}
              <option value="Surat"> Surat </option>{" "}
              <option value="Tawang"> Tawang </option>{" "}
              <option value="Thiruvananthpuram"> Thiruvananthpuram </option>{" "}
              <option value="Tirupati"> Tirupati </option>{" "}
              <option value="Udaipur"> Udaipur </option>{" "}
              <option value="Vadodara"> Vadodara </option>{" "}
              <option value="Varanasi"> Varanasi </option>{" "}
              <option value="Vijayawada"> Vijayawada </option>{" "}
              <option value="Visakhapatnam"> Visakhapatnam </option>{" "}
              <option value="Vrindavan"> Vrindavan </option>{" "}
              <option value="Warangal"> Warangal </option>{" "}
            </select>{" "}
            <input
              type="text"
              placeholder="Mobile Number"
              value={mobile}
              id="mobile_register"
              onChange={(val) => {
                setMobile(val.target.value);
              }}
              required
            />
          </div>

          <div className="input-group">
            <input
              type="email"
              placeholder="Email"
              value={email}
              id="email_register"
              onChange={(val) => {
                setEmail(val.target.value);
              }}
              disabled
              required
            />
          </div>

          <div className="input-group">
            <select
              id="service"
              value={service}
              onChange={(e) => {
                setService(e.target.selectedOptions[0].value);
              }}
              required
            >
              <option value=""> Select Service </option>{" "}
              <option value="Travel"> Travel </option>{" "}
              <option value="Wedding"> Wedding </option>{" "}
              <option value="Maternity"> Maternity </option>{" "}
              <option value="Baby"> Baby </option>{" "}
              <option value="Personal"> Personal </option>{" "}
              <option value="Business"> Business </option>{" "}
              <option value="Pre-Wedding"> Pre-Wedding </option>{" "}
              <option value="Post-Wedding"> Post-Wedding </option>{" "}
              <option value="Family"> Family </option>{" "}
              <option value="Other"> Other </option>{" "}
            </select>{" "}
            <select
              id="package"
              value={bookedPackage}
              price={bookedPackagePrice}
              onChange={(val) => {
                setPackage(val.target.value);
                setPackagePrice(
                  val.target.selectedOptions[0].attributes.price.value
                );
              }}
              required
            >
              <option value="" price="">
                {" "}
                Select Package{" "}
              </option>{" "}
              <option value="Bronze" price={bronze}>
                {" "}
                Bronze ({bronze}Rs.){" "}
              </option>{" "}
              <option value="Silver" price={silver}>
                {" "}
                Silver ({silver}Rs.){" "}
              </option>{" "}
              <option value="Gold" price={gold}>
                {" "}
                Gold ({gold}Rs.){" "}
              </option>{" "}
            </select>{" "}
          </div>

          <div className="input-group">
            <input
              type="date"
              id="bookingdate"
              value={date}
              min=""
              onClick={() => {
                var dtTod = new Date();

                var month = dtTod.getMonth() + 1;
                var day = dtTod.getDate() + 3;
                var year = dtTod.getFullYear();

                if (month < 10) {
                  month = "0" + month.toString();
                }
                if (day < 10) {
                  day = "0" + day.toString();
                }

                var maxDate = year + "-" + month + "-" + day;

                document
                  .getElementById("bookingdate")
                  .setAttribute("min", maxDate);
              }}
              onChange={(val) => {
                setDate(val.target.value);
              }}
              required
            />{" "}
            <select
              id="eventTime"
              value={time}
              onChange={(val) => {
                setTime(val.target.value);
              }}
              required
            >
              <option value="0">Select your time slot</option>
              <option value="6">06:00am</option>
              <option value="7">07:00am</option>
              <option value="8">08:00am</option>
              <option value="9">09:00am</option>
              <option value="10">10:00am</option>
              <option value="11">11:00am</option>
              <option value="12">12:00pm</option>
              <option value="13">1:00pm</option>
              <option value="14">2:00pm</option>
              <option value="15">3:00pm</option>
              <option value="16">4:00pm</option>
              <option value="17">5:00pm</option>
              <option value="18">6:00pm</option>
              <option value="19">7:00pm</option>
              <option value="20">8:00pm</option>
            </select>
          </div>

          <div className="input-group">
            <input
              type="text"
              placeholder="Comment (Optional)"
              id="comment"
              onChange={(val) => {
                setComment(val.target.value);
              }}
            />
          </div>

          <div className="input-group">
            <input
              type="text"
              placeholder="Coupon Code (Optional)"
              id="coupon-code"
              onChange={(val) => {
                setCoupon(val.target.value);
              }}
            />
          </div>
          <button
            className="book_package-submit_btn"
            // onClick={handleSubmit}
            type="submit"
          >
            Book Now
          </button>
        </form>
      </div>
    </div>
  );
};

export default NewUserDashboard;
